<template>
        
    <div class="card">
        <div class="card-body">

            <h4 
                class="card-title"
                :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''">
                {{ $t('app.number_of_payments') }}
            </h4>
            <div class="col-12 pd-0" style="padding:0">
                <input 
                    id="slug"
                    class="form-control text-lowercase" 
                    type="number"
                    v-model="row.number_of_payments"
                    @keydown.space.prevent 
                    @paste="onPaste"
                    v-on:input="onChange">
            </div>
        </div>
    </div>
        
</template>

<script>
export default {
    namme: 'CardNumberOfPayments',
    props: [
        'number_of_payments'
    ],
    data(){
        return {
            row: {
                number_of_payments: this.$props.number_of_payments
            },
        }
    },
    mounted() {},
    methods: {

        onChange(){
            const data = {
                number_of_payments: this.row.number_of_payments
            }
            this.$emit('numberOfPaymentsChange', data);
        },
        onPaste(){
            let str = this.row.number_of_payments;
            this.preventSpace(str);
        },
        preventSpace(str){
            if(!str) {
                let str = this.row.number_of_payments;
                this.row.number_of_payments = str.replace(/\s+/g, '-');
            } else {
                this.row.number_of_payments = str.replace(/\s+/g, '-');
            }
        },

    }
}
</script>
